module.exports = __webpack_public_path__ + "img/logo.0c4a3a5b.png";